// extracted by mini-css-extract-plugin
export default {"bg":"style_bg__zD6Jb","r1":"style_r1__1Vi-k","r2":"style_r2__KxhZB","r3":"style_r3__G78xw","r4":"style_r4__maqie"};